// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

import { Input, Label } from '@tectonics/look-and-feel/uber/commons/atoms';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { Field } from '@tectonics/look-and-feel/uber/commons/molecules';

export function AchPseAddressStreetName(): Node {
  const inputId = useUniqueId();
  const submitting = useSubmitting();
  const [value, handleChange] = useUserInputAsTextField('colombianAddress');
  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('colombianAddress');

  return (
    <Field
      data-test-name="address-street-name"
      label={<Label htmlFor={inputId}>Dirección</Label>}
      error={<ValidationErrorMessage validationError={validationError} />}
      hasError={formHasBeenSent && !!validationError}
    >
      <Input
        id={inputId}
        onChange={handleChange}
        placeholder="Calle, Avenida o Otro"
        readOnly={submitting}
        type="text"
        value={value}
        name="address-street-name"
      />
    </Field>
  );
}

type ValidationErrorMessageProps = {|
  validationError: ?UserInputValidationError,
|};

function ValidationErrorMessage({ validationError }: ValidationErrorMessageProps): Node {
  const fallback = useInvalidErrorByCountry();

  if(!validationError) {
    return fallback;
  }

  if (validationError.id === 'server-error') {
    return serverErrorMessage(validationError.payload, fallback);
  }

  return fallback;
}

function useInvalidErrorByCountry(): string {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'co':
      return 'El calle es inválido.';

    default:
      throw new Error(`Field Address Street Name: ${country} has no Invalid Street Name Error Message`);
  }
}
